import styled from "styled-components";

export const StyledButton = styled("button")<{ color?: string }>`
  background: ${(p) => p.color || "#ffe839"};
  color: ${(p) => (p.color ? "#ffe839" : "#161616")};
  font-size: 1rem;
  font-weight: 700;
  width: 100%;
  border: 2px solid #161616;
  border-radius: 4px;
  padding: 6px 0;
  cursor: pointer;
  max-width: 170px;
  width: 170px;
  transition: all 0.3s ease-in-out;

  @media only screen and (max-width: 768px) {
    max-width: 150px;
    width: 150px;
  }

  &:hover,
  &:active,
  &:focus {
    color: #ffe839;
    background-color: #161616;
  }
`;
